import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="image-carousel"
export default class extends Controller {
  static targets = ['imagesCarousel', 'carouselDots', 'dropzone', 'imagesPreviews']
  static values = {
    currentIndex: { type: Number, default: 0 },
    imagesCount: { type: Number, default: 0 },
    images: { type: Array, default: [] }
  }
  editMode = false;

  connect() {
    this.carouselDotsTarget.innerHTML = ''
    for (let i = 0; i < this.imagesCountValue; i++) {
      const dot = document.createElement('div')
      dot.classList.add('carousel-dot')
      this.carouselDotsTarget.appendChild(dot)
    }

    // this.addInitialImages()
    
    if (this.hasDropzoneTarget) {
      let inputTarget = this.dropzoneTarget.querySelector('input')
      inputTarget.addEventListener('change', this.addImage.bind(this))
      inputTarget.addEventListener('dragenter', this.handleDragEnter.bind(this))
      inputTarget.addEventListener('dragleave', this.handleDragLeave.bind(this))
      inputTarget.addEventListener('drop', this.handleDrop.bind(this))
      this.editMode = true;
    }
    this.updateCarousel()
  }

  disconnect() {
    if (this.hasDropzoneTarget) {
      let inputTarget = this.dropzoneTarget.querySelector('input')
      inputTarget.removeEventListener('change', this.addImage.bind(this))
      inputTarget.removeEventListener('dragenter', this.handleDragEnter.bind(this))
      inputTarget.removeEventListener('dragleave', this.handleDragLeave.bind(this))
      inputTarget.removeEventListener('drop', this.handleDrop.bind(this))
    }
  }

  addInitialImages() {
    this.imagesValue.reverse().forEach(image => {
      this.imagesCarouselTarget.insertBefore(this.imageHTML(image), this.dropzoneTarget)
    })
  }

  imageHTML(image) {
    const newImage = document.createElement('div')
    newImage.classList.add('image-carousel-item')
    newImage.innerHTML = `
      <img src="${image.url}" alt="${image.name}">
      <input id="adventure_adventure_images_attributes_${image.id}_image" name="adventure[adventure_images_attributes][${image.id}][image]" type="hidden">
      <input id="adventure_adventure_images_attributes_${image.id}__destroy" name="adventure[adventure_images_attributes][${image.id}][_destroy]" type="hidden">
      <i class="fa fa-trash" data-action="click->image-carousel#removeImage"></i>
      </div>
    `
    return newImage
  }

  prev() {
    this.currentIndexValue--
    if (this.currentIndexValue < 0) {
      this.currentIndexValue = this.imagesCountValue - 1;
    }
    this.updateCarousel();
  }

  next() {
    this.currentIndexValue++;
    if (this.currentIndexValue >= this.imagesCountValue) {
      this.currentIndexValue = 0;
    }
    this.updateCarousel();
  }

  setCurrentIndex(index) {
    this.currentIndexValue = index
    this.updateCarousel()
  }

  updateCarousel() {
    this.imagesCountValue = this.imagesCarouselTarget.children.length
    this.imagesCarouselTarget.style.width = `${this.imagesCountValue * 100}%`;
    this.imagesCarouselTarget.style.transform = `translateX(-${this.currentIndexValue / this.imagesCountValue * 100}%)`;

    // this.carouselDotsTarget.innerHTML = ''
    // for (let i = 0; i < this.imagesCountValue - 1; i++) {
    //   const dot = document.createElement('div')
    //   dot.classList.add('carousel-dot')
    //   if (i === this.currentIndexValue) {
    //     dot.classList.add('active')
    //   }
    //   dot.addEventListener('click', this.setCurrentIndex.bind(this, i))
    //   this.carouselDotsTarget.appendChild(dot)
    // }

    // const plus = document.createElement('i')
    // plus.classList.add('fa', 'fa-plus', 'carousel-plus')
    // if(this.currentIndexValue === this.imagesCountValue - 1) {
    //   plus.classList.add('active')
    // }
    // plus.addEventListener('click', this.setCurrentIndex.bind(this, this.imagesCountValue - 1))
    // this.carouselDotsTarget.appendChild(plus)

    this.imagesPreviewsTarget.innerHTML = ''
    let adjust = this.editMode ? 1 : 0;
    for (let i = 0; i < this.imagesCountValue - adjust; i++) {
      const preview = document.createElement('div')
      preview.classList.add('image-carousel-item')
      if (this.imagesValue[i].new_image) {
        preview.classList.add('new-image')
      }
      preview.addEventListener('click', this.setCurrentIndex.bind(this, i))
      if (i === this.currentIndexValue) {
        preview.classList.add('active')
      }

      let url = this.imagesValue[i].url
      let image = this.imagesValue[i].url

      if (this.imagesValue[i].remove_image) {
        preview.classList.add('to-delete')
        preview.innerHTML = `
        <img src="${image}" alt="${url}">
        <i class="fa fa-trash" data-action="click->image-carousel#unRemoveImage"></i>
      `
        
      } else {
        preview.classList.remove('to-delete')
        preview.innerHTML = `
        <img src="${image}" alt="${url}">
      `
      }
      this.imagesPreviewsTarget.appendChild(preview)
    }

    if (this.editMode) {
      const preview_plus = document.createElement('div')
      preview_plus.classList.add('image-carousel-item')

      if(this.currentIndexValue === this.imagesCountValue - 1) {
        preview_plus.classList.add('active')
      }

      preview_plus.innerHTML = `
        <i class="fa fa-plus"></i>
      `
      preview_plus.addEventListener('click', this.setCurrentIndex.bind(this, this.imagesCountValue - 1))
      this.imagesPreviewsTarget.appendChild(preview_plus)
    }

    if (this.imagesCountValue < 2 && !this.editMode) {
      this.imagesCarouselTarget.parentElement.querySelector('.fa-chevron-left').classList.add('hidden')
      this.imagesCarouselTarget.parentElement.querySelector('.fa-chevron-right').classList.add('hidden')
    } else {
      this.imagesCarouselTarget.parentElement.querySelector('.fa-chevron-left').classList.remove('hidden')
      this.imagesCarouselTarget.parentElement.querySelector('.fa-chevron-right').classList.remove('hidden')
    }
  }

  removeImage(event) {
    event.preventDefault();
    window.tess = event.target

    if (this.imagesValue[this.currentIndexValue].new_image !== true) {
      let images = this.imagesValue;
      images[this.currentIndexValue].remove_image = true
      this.imagesValue = images;

      event.target.closest('.image-carousel-item').querySelector(`input[name="adventure[adventure_images_attributes][${this.currentIndexValue}][_destroy]"]`).value = 'true'
      event.target.closest('.image-carousel-item').querySelector('.fa-trash').removeEventListener('click', this.removeImage.bind(this))
      event.target.closest('.image-carousel-item').querySelector('.fa-trash').addEventListener('click', this.unRemoveImage.bind(this))
      event.target.closest('.image-carousel-item').classList.add('to-delete')
    } else {
      event.target.closest('.image-carousel-item').remove()

      this.imagesValue = this.imagesValue.map((image, index) => {
        if (index === this.currentIndexValue) {
          return null
        }
        return image
      }).filter(image => image !== null)
  
      if (this.currentIndexValue > 0) {
        this.currentIndexValue--;
      }
    }    
    
    this.updateCarousel()
  }

  unRemoveImage(event) {
    event.preventDefault();

    let images = this.imagesValue;
    images[this.currentIndexValue].remove_image = false
    this.imagesValue = images;

    event.target.closest('.image-carousel-item').classList.remove('to-delete')
    event.target.closest('.image-carousel-item').querySelector(`input[name="adventure[adventure_images_attributes][${this.currentIndexValue}][_destroy]"]`).value = 'false'
    event.target.closest('.image-carousel-item').querySelector('.fa-trash').removeEventListener('click', this.unRemoveImage.bind(this))
    event.target.closest('.image-carousel-item').querySelector('.fa-trash').addEventListener('click', this.removeImage.bind(this))
    this.updateCarousel()
  }

  addImage(event) {
    event.preventDefault();

    // add preview of image to the carousel before the new image input
    const newImage = document.createElement('div')
    newImage.classList.add('image-carousel-item')
    newImage.classList.add('new-image')

    let file = event.target.files[0]

    const reader = new FileReader()

    reader.onload = (e) => {
      const base64Data = e.target.result;
      let new_index = this.imagesCountValue - 1;
      newImage.innerHTML = `
        <img src="${URL.createObjectURL(file)}" alt="${file.name}">
        <input id="adventure_adventure_images_attributes_${new_index}_image" name="adventure[adventure_images_attributes][${new_index}][image]" type="hidden" value="${base64Data}">
        <input id="adventure_adventure_images_attributes_${new_index}__destroy" name="adventure[adventure_images_attributes][${new_index}][_destroy]" type="hidden">
        <i class="fa fa-trash" data-action="click->image-carousel#removeImage"></i>
      `

      this.imagesCarouselTarget.insertBefore(newImage, this.dropzoneTarget);

      event.target.value = '';

      let images = this.imagesValue;

      images.push({
        id: this.imagesCountValue,
        url: base64Data,
        new_image: true
      })

      this.imagesValue = images;

      this.updateCarousel();
    }

    reader.readAsDataURL(file)
  }

  handleDragEnter(event) {
    event.preventDefault();
    this.dropzoneTarget.classList.add('drag-enter')
    }

  handleDragLeave(event) {
    event.preventDefault();
    this.dropzoneTarget.classList.remove('drag-enter')
  }

  handleDrop(event) {
    event.preventDefault();
    this.dropzoneTarget.classList.remove('drag-enter')
  }

  //todo potentially do this later
  // rotateLeft() {
  //   // rotate the current image left by 90 degrees
  //   let currentImage = this.imagesCarouselTarget.querySelector('.image-carousel-item').querySelector('img')
  //   let currentRotation = 0
  //   if (currentImage.style.transform) {
  //     currentRotation = currentImage.style.transform.split('(')[1].split(')')[0].replace('deg', '')
  //   }
  //   currentImage.style.transform = `rotate(${currentRotation - 90}deg)`
  //   currentImage.style.transformOrigin = 'center'
  //   currentImage.style.transition = 'transform 0.3s ease-in-out'
  //   this.updateCarousel()
  // }
  // rotateRight() {
  // }

  
}
